<template>
  <div
    class="rete-canvas-menu"
    role="menu"
    aria-label="Ações do canvas"
    :style="{ left: `${position.left}px`, top: `${position.top}px` }"
    @pointerdown.stop
    @click.stop
    @contextmenu.prevent.stop
    @keydown.esc.stop.prevent="$emit('close')"
  >
    <button
      v-if="position.connectionId"
      ref="add"
      type="button"
      role="menuitem"
      @click="$emit('remove-link', position.connectionId)"
    >
      <i class="fas fa-unlink" aria-hidden="true"></i>
      Apagar link
    </button>
    <button
      v-else
      ref="add"
      type="button"
      role="menuitem"
      @click="$emit('add')"
    >
      <i class="fas fa-plus" aria-hidden="true"></i>
      Adicionar estágio aqui
    </button>
    <button
      v-if="!position.connectionId"
      type="button"
      role="menuitem"
      @click="$emit('search')"
    >
      <i class="fas fa-search" aria-hidden="true"></i>
      Buscar estágio
    </button>
  </div>
</template>

<script>
export default {
  props: { position: { type: Object, required: true } },
  mounted() {
    this.$refs.add.focus({ preventScroll: true });
    document.addEventListener("pointerdown", this.dismiss, true);
    document.addEventListener("wheel", this.dismiss, {
      capture: true,
      passive: true
    });
    window.addEventListener("resize", this.dismiss);
  },
  beforeDestroy() {
    document.removeEventListener("pointerdown", this.dismiss, true);
    document.removeEventListener("wheel", this.dismiss, true);
    window.removeEventListener("resize", this.dismiss);
  },
  methods: {
    dismiss(event) {
      if (!this.$el.contains(event.target)) this.$emit("close");
    }
  }
};
</script>

<style scoped>
.rete-canvas-menu {
  background: #fff;
  border: 1px solid #e5dced;
  border-radius: 10px;
  box-shadow: 0 8px 30px #29163826;
  padding: 5px;
  position: fixed;
  width: 226px;
  z-index: 3100;
}
.rete-canvas-menu button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #51405f;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  gap: 10px;
  padding: 12px 10px;
  width: 100%;
}
.rete-canvas-menu button:hover,
.rete-canvas-menu button:focus-visible {
  background: #f4effa;
  color: #7047a4;
  outline: none;
}
</style>
